import { type EftBankActivity } from '@egw/api'

export const getLocation = (transaction: EftBankActivity): string => {
  const address = []
  transaction.location?.street && address.push(transaction.location.street)
  transaction.location?.city && address.push(transaction.location.city)
  transaction.location?.region && address.push(transaction.location.region)
  transaction.location?.postalCode && address.push(transaction.location.postalCode)
  transaction.location?.country && address.push(transaction.location.country)
  return address.join(', ')
}
